import { createContext, FunctionComponent, ReactElement, useContext } from "react";
import GetEventsBatismo, { ResponseEventBatismo } from "../CrudEventos/services/getEvents";

const servicesContext = createContext<ResponseEventBatismo>(null)


interface ProviderServicesEventProps {

}

const ProviderServicesEvent: FunctionComponent<ProviderServicesEventProps> = ({children}: { children: ReactElement }) => {

  const context = GetEventsBatismo()

  return (
  <servicesContext.Provider value={context}>
    {children}
  </servicesContext.Provider>
  );
}

export default ProviderServicesEvent;

export const UseServicesEvent = () => {
  const context = useContext(servicesContext);

  return context;
}
